import { memo } from "react";

const CARDS = [
  { key: "protein", label: "Protein", unit: "g" },
  { key: "carbs", label: "Carbs", unit: "g" },
  { key: "fat", label: "Fats", unit: "g" },
  { key: "calories", label: "Calories", unit: "" },
];

const valueText = (value, unit) => {
  if (value === null || value === undefined) return "—";
  return unit ? `${Number(value.toFixed(1))}${unit}` : String(Math.round(value));
};

export const NutritionSummaryCard = memo(function NutritionSummaryCard({ label, value, unit, basis, highlight }) {
  return (
    <div className={`ep-summary ${highlight ? "is-key" : ""}`}>
      <b>{valueText(value, unit)}</b>
      <span>{label}</span>
      <small>{basis}</small>
    </div>
  );
});

/**
 * Protein / Carbs / Fats / Calories. `basis` says what the values are for:
 * "per 100g" or a pack ("per 250 g").
 */
function NutritionSummary({ values, basis = "per 100g" }) {
  return (
    <div className="ep-summary-grid">
      {CARDS.map(({ key, ...card }) => (
        <NutritionSummaryCard key={key} value={values?.[key] ?? null} basis={basis} highlight={key === "protein"} {...card} />
      ))}
    </div>
  );
}

export default memo(NutritionSummary);
